import {Subject} from "rxjs";
import {SettingsEventTypes} from "./SettingsEventTypes";
import {logger} from "../../log/logger";
import {IVolumes} from "../../../redux/types/IVolumes";
const settingsSubject = new Subject<SettingsEventTypes>();

/**
 * Subscribe to events related to segment.
 * Returns unsubscribe function
 * @param callback - function to be executed whenever an event is emitted via call to Subject next()
 */
export function subscribeToSettingsEvents(callback: (message: SettingsEventTypes) => void){
  const protectedCallback = (message: SettingsEventTypes) => {
    try{
      callback(message);
    }catch(e) {
      logger.lessonSettings.error({message: `error encountered in observer of SettingsEventTypes `, error: e as Error});
    }
  };
  const subscription = settingsSubject.subscribe(protectedCallback);
  return subscription.unsubscribe.bind(subscription);
}

function emitSegmentMessage(message: SettingsEventTypes){
  return settingsSubject.next(message);
}

export function audioContextSampleRateChanged(){
  return emitSegmentMessage({type: "audioContextSampleRateChanged"});
}

export function currentlySelectedMidiInputChanged(device: string, name: string){
  return emitSegmentMessage({type: "currentlySelectedMidiInputChanged", device, name});
}

export function currentlySelectedSoundLibraryChanged(library: string){
  return emitSegmentMessage({type: "currentlySelectedSoundLibraryChanged", library});
}

export function volumesChanged(volumes: IVolumes){
  return emitSegmentMessage({type:"volumesChanged", volumes});
}